import { NgModule } from "@angular/core";
import { WkIconUser2SpritePds3 } from "./wk-icon-user-sprite-pds3";
import { WkIconNoRecordsSpritePds3 } from "./wk-icon-no-records-sprite-pds3";

@NgModule({
    declarations: [],
    imports: [WkIconUser2SpritePds3, WkIconNoRecordsSpritePds3],
    exports: [WkIconUser2SpritePds3, WkIconNoRecordsSpritePds3],
})
export class IconsModule {}
